module.exports = __webpack_public_path__ + "fonts/raraya_font.da26b439.ttf";